module.exports = __webpack_public_path__ + "88f5de011804ecd198a7f468726808a2.pdf";